import axios from 'axios'

const LogThis = (user, type, course) => {
  console.log(user, type, course)
  /*
    here is what you'll get:
    user.userName
    user.userId
    user.userEmail
    user.userGroup -------- only logged if the user group is 9 (da-prospects)
    user.salesContact
    type = enter, exit, view
    course - 'Name of the course', if applicable
  */

  if (user.userGroup === '9') {
    // log it up!

    const loggingData = {
      userId: user.userId,
      userName: user.userName,
      userEmail: user.userEmail,
      userFirstName: user.userFirstName,
      userLastName: user.userLastName,
      salesContact: user.salesContact,
      type: type,
      course: course
    }

    const loggingToSend = JSON.stringify(loggingData)

    axios
      .post('/scripts/jake/email/mail-me.php', loggingToSend)
      .then(res => {
        console.log(loggingToSend)
        console.log(res.data)
      })
      .catch(error => {
        console.log(error)
      })
  }
}

export default LogThis
